import React, { useState } from 'react'
import { CalendarOutlined } from '@ant-design/icons'
import { Button, App } from '@surecompanies/core_components'
import EditEnrollmentDatesModal from './EditEnrollmentDatesModal'
import {
  notifyRescheduleResult,
  RescheduleEnrollmentDatesDto,
  useEnrollmentPeriodDates,
} from '../hooks/useEnrollmentPeriodDates'
import { EnrollmentConfiguration } from '../hooks/useEnrollmentConfiguration'

/**
 * The company-wide "Edit Dates" button shown on an OEP's header — reschedules
 * or extends the enrollment window for every employee currently tied to this
 * OEP's Benefit Effective Date, and cascades the change to the company-level
 * OEP record itself (applyToAllEnrolled: true).
 */
export default function EditEnrollmentDatesButton({
  id,
  enrollment,
}: {
  id: string
  enrollment: EnrollmentConfiguration
}) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { rescheduleEnrollmentMutation } = useEnrollmentPeriodDates(id)

  const {
    mutate: rescheduleEnrollment,
    isPending,
    error: mutationError,
    reset: resetMutation,
  } = rescheduleEnrollmentMutation()

  const handleOpen = () => {
    setIsModalOpen(true)
  }

  const handleClose = () => {
    setIsModalOpen(false)
    resetMutation()
  }

  const handleConfirm = (
    dto: Omit<RescheduleEnrollmentDatesDto, 'personIds'>
  ) => {
    rescheduleEnrollment(
      { enrollmentId: enrollment.id.toString(), dto },
      {
        onSuccess: (data) => {
          notifyRescheduleResult(data)
          setIsModalOpen(false)
        },
      }
    )
  }

  return (
    <App>
      <Button
        variant="solid"
        type="primary"
        icon={<CalendarOutlined />}
        onClick={handleOpen}
      >
        Edit Dates
      </Button>
      <EditEnrollmentDatesModal
        open={isModalOpen}
        mode="all"
        enrollment={enrollment}
        isSubmitting={isPending}
        serverError={mutationError?.message}
        onClose={handleClose}
        onConfirm={handleConfirm}
      />
    </App>
  )
}
